import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './components/Home';
import UpcomingEvent from './components/UpcomingEvent';
import About from './components/About';
import Programs from './components/Programs';
import Objectives from './components/Objectives';
import Contact from './components/Contact';
import Donate from './components/Donate';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import MissionEducation from './components/MissionEducation';
import MissionSkillsDevelopment from './components/MissionSkillsDevelopment';
import MissionYouthDevelopment from './components/MissionYouthDevelopment';
import MissionSpiritualUpliftment from './components/MissionSpiritualUpliftment';
import MissionPovertyAlleviation from './components/MissionPovertyAlleviation';
import MissionCommunityHelpline from './components/MissionCommunityHelpline';
import SiteInProgress from './components/SiteInProgress';
import './App.css';

// Set to true to show the temporary "site in progress" page for all routes.
const SITE_IN_PROGRESS_MODE = false;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      {SITE_IN_PROGRESS_MODE ? (
        <SiteInProgress />
      ) : (
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/upcoming-events" element={<UpcomingEvent />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/objectives" element={<Objectives />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mission/education" element={<MissionEducation />} />
            <Route path="/mission/skills-development" element={<MissionSkillsDevelopment />} />
            <Route path="/mission/youth-development" element={<MissionYouthDevelopment />} />
            <Route path="/mission/spiritual-upliftment" element={<MissionSpiritualUpliftment />} />
            <Route path="/mission/poverty-alleviation" element={<MissionPovertyAlleviation />} />
            <Route path="/mission/community-helpline" element={<MissionCommunityHelpline />} />
          </Routes>
          <Footer />
        </div>
      )}
    </Router>
  );
}

export default App;
